import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function FacilityOrderTemplateItemNewFlowActivatePatientModalTemplate({ facilityOrderTemplateItemNewFlowActivatePatientModalStore, t }) {
    const {
        patient,
        activatePatient,
        modalParams,
        disabled
    } = facilityOrderTemplateItemNewFlowActivatePatientModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Do you want to activate this patient again?</h3>
            </div>
            <div className="modal__body">
                <b>"{patient && patient.lastName && `${patient.lastName}`}
                    {patient && patient.lastName && patient.firstName && ', '}
                    {patient && patient.firstName && `${patient.firstName}`}"
                </b> patient is discharged. By activating it, it will go to the In Progress tab.
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label={t('EDIT_FORM_LAYOUT.ACTIVATE')}
                    onClick={() => activatePatient()}
                    disabled={disabled}
                    rotate
                    icon={
                        disabled
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}

FacilityOrderTemplateItemNewFlowActivatePatientModalTemplate.propTypes = {
    facilityOrderTemplateItemNewFlowActivatePatientModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateItemNewFlowActivatePatientModalTemplate);
